module.exports = {
  sanity: {
    projectId: process.env.SANITY_PROJECT_ID || 'v13axw65',
    dataset: process.env.SANITY_DATASET || 'production',
  },
};
